var map = {
	"./draken_01.svg": 70997,
	"./draken_02.svg": 58038,
	"./draken_03.svg": 97575,
	"./f-16_01.svg": 2182,
	"./f-16_02.svg": 24613,
	"./f-16_03.svg": 57092,
	"./f-22_01.svg": 221,
	"./f-2_01.svg": 3853,
	"./f-35a_01.svg": 65788,
	"./mig-29_01.svg": 25375,
	"./mirage_01.svg": 83507,
	"./mirage_02.svg": 22496,
	"./rafale_01.svg": 56963,
	"./rafale_02.svg": 90864,
	"./rafale_03.svg": 89313,
	"./rafale_04.svg": 45758,
	"./su-57_01.svg": 94443,
	"./su-57_02.svg": 55608,
	"./typhoon_01.svg": 85869,
	"./typhoon_02.svg": 75150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72320;